/* Chart orchestration. The shared astronomy adapter is the only ephemeris boundary. */
(() => {
  'use strict';
  const root=typeof window==='undefined'?globalThis:window;
  const bodies=['Sun','Moon','Mercury','Venus','Mars','Jupiter','Saturn','Uranus','Neptune','Pluto'];
  const adapter=()=>root.MoonmeetAstronomy.create(root.Astronomy);
  function placement(longitude, margin=.05) {
    if (!Number.isFinite(longitude)) throw Error('calculation');
    const normalized=root.MoonmeetAstronomy.normalize(longitude), degree=normalized%30, sign=Math.floor(normalized/30);
    const possible=[sign];
    if (degree < margin) possible.unshift((sign+11)%12);
    if (30-degree < margin) possible.push((sign+1)%12);
    return {longitude:normalized,sign,degree,possible};
  }
  function quick(day, now=Date.now()) {
    root.MoonmeetTimezones.date(day,now);
    const start=Date.parse(day+'T00:00:00Z')-14*3600000, end=start+50*3600000;
    const possible=new Set(), a=adapter();
    for(let t=start;t<end;t+=3*3600000) for(const sign of placement(a.longitude('Sun',t)).possible) possible.add(sign);
    for(const sign of placement(a.longitude('Sun',end)).possible) possible.add(sign);
    return {mode:'quick',possible:[...possible],start,end};
  }
  function snapshot(time, city) {
    if (!Number.isFinite(time) || time<Date.parse('1900-01-01T00:00:00Z') || time>Date.now()) throw Error('date_range');
    const a=adapter(), planets=bodies.map(body=>({body,...placement(a.longitude(body,time))}));
    const asc=a.ascendant(time,city.latitude,city.longitude);
    if(asc.available) {
      Object.assign(asc,placement(asc.longitude,.1));
      // Minute-entry and city-center uncertainty deserve extra caution near an ingress.
      const near=[time-60000,time+60000].flatMap(t=>placement(a.ascendant(t,city.latitude,city.longitude).longitude,.1).possible);
      asc.possible=[...new Set([...asc.possible,...near])];
    }
    return {mode:'timed',time,planets,ascendant:asc};
  }
  root.MoonmeetChartCore=Object.freeze({bodies,placement,quick,snapshot});
})();
